export default {
  en: {
    status: {
      unavailable: 'unavailable',
      reserved: 'reserved',
      pending: 'pending',
      declined: 'declined',
      canceled: 'canceled',
    },
  },
};
